import React, { useState } from "react";

/// A 0fr↔1fr height fold whose content fades in once it has opened and out
/// before it closes. Children mount the moment it opens — during render, so the
/// height animates from the real content — and unmount once it has closed, so
/// a closed fold costs nothing at rest. A plain block root, not a flex child,
/// so Safari reflows the siblings continuously as it grows.
export const Fold: React.FC<{
  open: boolean;
  className?: string;
  children: React.ReactNode;
}> = ({ open, className = "", children }) => {
  const [render, setRender] = useState(open);
  if (open && !render) setRender(true);
  return (
    <div
      className={`grid ${className}`}
      style={{
        gridTemplateRows: open ? "1fr" : "0fr",
        transition: "grid-template-rows var(--duration-short) var(--ease-move)",
        transitionDelay: open ? "0ms" : "var(--duration-micro)",
      }}
      onTransitionEnd={(e) => {
        // A nested fold's transition bubbles up with the same property name.
        if (
          e.target === e.currentTarget &&
          e.propertyName === "grid-template-rows" &&
          !open
        )
          setRender(false);
      }}
    >
      <div className="overflow-hidden" style={{ minHeight: 0 }}>
        <div
          style={{
            opacity: open ? 1 : 0,
            transition: "opacity var(--duration-micro) var(--ease-move)",
            transitionDelay: open ? "var(--duration-short)" : "0ms",
          }}
        >
          {render && children}
        </div>
      </div>
    </div>
  );
};
